import { loadAndMigrateState, Migrator } from '@ps20-frontend/migrations';
import { IAppState } from '../appState';

export const stateMigrators: Migrator[] = [];

export const loadAndMigrateTgvState = (
  currentState: IAppState,
  loadedState: { version: number },
): IAppState => loadAndMigrateState(currentState, loadedState, stateMigrators);
